import DigitalAssetkActionTypes from './digitalAssets-types'

export const startFetchAvailableDigitalAssets = data => ({
    type: DigitalAssetkActionTypes.START_FETCH_AVAILABLE_DIGITAL_ASSETS,
    payload: data,
})
export const successFetchAvailableDigitalAssets = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_FETCH_AVAILABLE_DIGITAL_ASSETS,
    payload: data,
})
export const finishFetchAvailableDigitalAssets = data => ({
    type: DigitalAssetkActionTypes.FINISH_FETCH_AVAILABLE_DIGITAL_ASSETS,
    payload: data,
})
export const failureFetchAvailableDigitalAssets = data => ({
    type: DigitalAssetkActionTypes.FAILURE_FETCH_AVAILABLE_DIGITAL_ASSETS,
    payload: data,
})

export const startAddDigitalAsset = data => ({
    type: DigitalAssetkActionTypes.START_ADD_DIGITAL_ASSET,
    payload: data,
})
export const successAddDigitalAsset = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_ADD_DIGITAL_ASSET,
    payload: data,
})
export const finishAddDigitalAsset = data => ({
    type: DigitalAssetkActionTypes.FINISH_ADD_DIGITAL_ASSET,
    payload: data,
})
export const failureAddDigitalAsset = data => ({
    type: DigitalAssetkActionTypes.FAILURE_ADD_DIGITAL_ASSET,
    payload: data,
})
export const completeLoaderAddDigitalAsset = data => ({
    type: DigitalAssetkActionTypes.COMPLETE_REQUEST_ADD_DIGITAL_ASSET,
    payload: data,
})

export const startSendDigitalAssetsAmount = data => ({
    type: DigitalAssetkActionTypes.START_SEND_DIGITAL_ASSETS_AMOUNT,
    payload: data,
})
export const successSendDigitalAssetsAmount = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_SEND_DIGITAL_ASSETS_AMOUNT,
    payload: data,
})
export const finishSendDigitalAssetsAmount = data => ({
    type: DigitalAssetkActionTypes.FINISH_SEND_DIGITAL_ASSETS_AMOUNT,
    payload: data,
})
export const failureSendDigitalAssetsAmount = data => ({
    type: DigitalAssetkActionTypes.FAILURE_SEND_DIGITAL_ASSETS_AMOUNT,
    payload: data,
})

export const startTransferUsdcCoin = data => ({
    type: DigitalAssetkActionTypes.START_TRANSFER_USDC_COIN,
    payload: data,
})
export const successTransferUsdcCoin = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_TRANSFER_USDC_COIN,
    payload: data,
})
export const finishTransferUsdcCoin = data => ({
    type: DigitalAssetkActionTypes.FINISH_TRANSFER_USDC_COIN,
    payload: data,
})
export const failureTransferUsdcCoin = data => ({
    type: DigitalAssetkActionTypes.FAILURE_TRANSFER_USDC_COIN,
    payload: data,
})

export const startSendUsdcCoin = data => ({
    type: DigitalAssetkActionTypes.START_SEND_USDC_COIN,
    payload: data,
})
export const successSendUsdcCoin = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_SEND_USDC_COIN,
    payload: data,
})
export const finishSendUsdcCoin = data => ({
    type: DigitalAssetkActionTypes.FINISH_SEND_USDC_COIN,
    payload: data,
})
export const failureSendUsdcCoin = data => ({
    type: DigitalAssetkActionTypes.FAILURE_SEND_USDC_COIN,
    payload: data,
})

export const startGetEncryptionKey = data => ({
    type: DigitalAssetkActionTypes.START_GET_ENCRYPTION_KEY,
    payload: data,
})
export const successGetEncryptionKey = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_GET_ENCRYPTION_KEY,
    payload: data,
})
export const finishGetEncryptionKey = data => ({
    type: DigitalAssetkActionTypes.FINISH_GET_ENCRYPTION_KEY,
    payload: data,
})
export const failureGetEncryptionKey = data => ({
    type: DigitalAssetkActionTypes.FAILURE_GET_ENCRYPTION_KEY,
    payload: data,
})

export const startBuyUsdcCoinWithBank = data => ({
    type: DigitalAssetkActionTypes.START_BUY_USDC_COIN_WITH_BANK,
    payload: data,
})
export const successBuyUsdcCoinWithBank = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_BUY_USDC_COIN_WITH_BANK,
    payload: data,
})
export const finishBuyUsdcCoinWithBank = data => ({
    type: DigitalAssetkActionTypes.FINISH_BUY_USDC_COIN_WITH_BANK,
    payload: data,
})
export const failureBuyUsdcCoinWithBank = data => ({
    type: DigitalAssetkActionTypes.FAILURE_BUY_USDC_COIN_WITH_BANK,
    payload: data,
})

/*************************  Receive digital asset beneficiaries ************************** */

export const startReceiveDigitalAssetBenaficiaries = data => ({
    type: DigitalAssetkActionTypes.START_RECEIVE_DIGITAL_ASSET_BENEFICIARIES,
    payload: data,
})

export const successReceiveDigitalAssetBenaficiaries = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_RECEIVE_DIGITAL_ASSET_BENEFICIARIES,
    payload: data,
})

export const finishReceiveDigitalAssetBenaficiaries = data => ({
    type: DigitalAssetkActionTypes.FINISH_RECEIVE_DIGITAL_ASSET_BENEFICIARIES,
    payload: data,
})

export const failureReceiveDigitalAssetBenaficiaries = data => ({
    type: DigitalAssetkActionTypes.FAILURE_RECEIVE_DIGITAL_ASSET_BENEFICIARIES,
    payload: data,
})

/*************************  Receive digital asset beneficiaries ************************** */

export const startGetDigitalAssetWalletById = data => ({
    type: DigitalAssetkActionTypes.START_GET_DIGITAL_ASSET_WALLET_BY_ID,
    payload: data,
})

export const successGetDigitalAssetWalletById = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_GET_DIGITAL_ASSET_WALLET_BY_ID,
    payload: data,
})

export const finishGetDigitalAssetWalletById = data => ({
    type: DigitalAssetkActionTypes.FINISH_GET_DIGITAL_ASSET_WALLET_BY_ID,
    payload: data,
})

export const failureGetDigitalAssetWalletById = data => ({
    type: DigitalAssetkActionTypes.FAILURE_GET_DIGITAL_ASSET_WALLET_BY_ID,
    payload: data,
})

/*************************  Get digital asset wallet in our system or not ************************** */

export const startGetDigitalAssetWalletAddressType = data => ({
    type: DigitalAssetkActionTypes.START_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE,
    payload: data,
})

export const successGetDigitalAssetWalletAddressType = data => ({
    type: DigitalAssetkActionTypes.SUCCESS_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE,
    payload: data,
})

export const finishGetDigitalAssetWalletAddressType = data => ({
    type: DigitalAssetkActionTypes.FINISH_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE,
    payload: data,
})

export const failureGetDigitalAssetWalletAddressType = data => ({
    type: DigitalAssetkActionTypes.FAILURE_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE,
    payload: data,
})
